import ColleaguesInDealCard from './ColleaguesInDealCard.component';

export default ColleaguesInDealCard;